import React, { Component, Fragment, createRef } from "react";

import "component/listItem/Category/styles.scss";
import { PlayIcon } from "component/icons";
import { ReactComponent as CrownIcon } from "assets/icons/Jackpot.svg";
import { ReactComponent as TrophyIcon } from "assets/icons/Tournament.svg";
import { ReactComponent as RibbonIcon } from "assets/icons/FreeRounds.svg";
import { ReactComponent as EditorsChoiceIcon } from "assets/icons/editors-badge.svg";
import {
  jackpotCurrencyFormatter,
  currencyFormatter,
} from "utils/currencyHelper";
import Highlighter from "react-highlight-words";
import { setDefaultImageFormat } from "utils/image";
import { getTotalPool } from "utils/getTotalpool";

import defaultBanner from "assets/images/bannerDefault.png";

class Category extends Component {
  constructor(props) {
    super(props);
    this.checkSentence = this._checkSentence.bind(this);
    this.onMouseOverHandler = this._onMouseOverHandler.bind(this);
    this.checkIfCached = this._checkIfCached.bind(this);
    this.getTotalPool = getTotalPool.bind(this);
    let jackpot = null;
    this.mainComponent = createRef();
    this.bannerDefaultRef = createRef();

    if (props.game && props.game.get("jackpotBalance")) {
      jackpot = jackpotCurrencyFormatter(props.game.get("jackpotBalance"), {
        currency: this.props.currency,
      });
    }
    this.state = {
      hovered: false,
      isLoadingImage: true,
      imgSrc: props.game
        ? `${setDefaultImageFormat(
            this.props.game.getIn(["images", "bannerUrl"]) +
              "&width=450&theme=dark",
            this.props.imageFormat.get("banner"),
          )}`
        : null,
      jackpot: jackpot,
      isVisible: false,
      jackpotPool: null,
    };
  }

  _checkSentence(sentence, searchArr) {
    // Split the sentence into words
    const words = sentence.split(" ");

    const firstLetters = words.map((word) => word.charAt(0));
    let hasFirtLetters;

    const test = searchArr.map((search, i) => {
      if (search === "") {
        return null;
      }

      const index = firstLetters
        .join("")
        .toLocaleLowerCase()
        .indexOf(search.toLocaleLowerCase());
      hasFirtLetters = index > -1;

      if (index > -1) {
        let renderedWord = words.map((word, j) => {
          if (index <= j && j - index <= search.length - 1) {
            return (
              <Fragment key={j}>
                <span className="matched-search">{word[0]}</span>
                <span>{word.slice(1)}</span>
              </Fragment>
            );
          } else {
            return <span key={j}>{word}</span>;
          }
        });
        return <>{renderedWord}</>;
      }
      return null;
    });

    if (hasFirtLetters) {
      return test;
    }

    return (
      <Highlighter
        highlightClassName="matched-search"
        searchWords={searchArr}
        textToHighlight={sentence}
      />
    );
  }

  _onMouseOverHandler(bol) {
    this.setState({
      hovered: bol,
    });
  }

  _checkIfCached(src) {
    let img = new Image();
    img.src = src;
    let isCached = img.complete;
    let hasNaturalWidth = !(img.naturalWidth === 0);
    img = null;
    if (!isCached || !hasNaturalWidth) {
      return false;
    }

    return true;
  }

  componentDidMount() {
    this.initObserver();
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.mainComponent.current) {
                this.setState({
                  isVisible: true,
                });
              }
            } else {
              if (this.mainComponent.current) {
                //clearInterval(this.initLoadDelay)
              }
            }
          });
        },
        {
          //rootMargin: '500px 0px 500px 0px'
          root: this.props.parent,
          rootMargin: "0px 0px 0px 0px",
        },
      );
      observer.observe(this.mainComponent.current);
    } else {
      //this.getGames(this.props.link);
      //this.getTournamentPreview(this.props.links)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.latestBroadcast &&
      nextProps.latestBroadcast.get("jackpotGroupId") ===
        this.props.game.get("jackpotGroupId")
    ) {
      let latestJackpotPool;
      latestJackpotPool = {
        type: nextProps.latestBroadcast.get("type"),
        amount: nextProps.latestBroadcast.get("amount"),
      };
      this.setState({
        jackpotPool: {
          ...this.state.jackpotPool,
          [latestJackpotPool.type]: { amount: latestJackpotPool.amount },
        },
      });
    } else {
      this.setState({ jackpotPool: null });
    }

    if (nextProps.game && nextProps.game !== this.props.game) {
      let jackpot;
      let imgSrc = `${nextProps.game.getIn([
        "images",
        "bannerUrl",
      ])}&width=450&theme=dark`;

      if (nextProps.game.get("jackpotBalance")) {
        jackpot = jackpotCurrencyFormatter(
          nextProps.game.get("jackpotBalance"),
          {
            currency: this.props.currency,
            symbol: this.props.symbol,
          },
        );
      }
      this.setState({
        imgSrc: imgSrc,
        jackpot: jackpot,
      });
    }
  }

  renderSkeleton() {
    return (
      <div>
        <div className="category-type">
          <img
            src={defaultBanner}
            className={`img-fluid w-100  ${
              this.state.isLoadingImage ? "" : "d-none"
            } `}
            alt="name"
          />
          <div className="labelRow">
            <span className="label">
              <div className="name">
                <span className="dummy">XXXXXXXXXXX</span>
              </div>
              <div className="provider">
                <span className="dummy">XXXXXXXXXXX</span>
              </div>
              <div className="game-type">
                <span className="dummy">XXXXXXXXXXX</span>
              </div>
            </span>
          </div>
        </div>
      </div>
    );
  }

  render() {
    let { game, filter, gameLimit } = this.props;

    //debugger;

    let searchArr;

    if (filter) {
      searchArr = filter.split(" ");
    }

    return (
      <div
        className={this.props.className}
        onMouseOver={() => {
          this.onMouseOverHandler(true);
        }}
        onMouseOut={() => {
          this.onMouseOverHandler(false);
        }}
        onClick={(event) => {
          if (this.props.linkDetails && this.props.onClick) {
            this.props.onClick(this.props.linkDetails.get("rel"));
          }
          event.stopPropagation();
        }}
        ref={this.mainComponent}
      >
        {!game && this.renderSkeleton()}
        {game && (
          <div className="category-type">
            <div className="img-holder">
              {this.state.isVisible && (
                <img
                  src={this.state.imgSrc}
                  className={`img-fluid w-100 ${
                    this.state.isLoadingImage ? "d-none" : ""
                  }`}
                  alt={game.get("name")}
                  onLoad={({ currentTarget }) => {
                    this.setState({
                      isLoadingImage: false,
                    });
                  }}
                />
              )}
              <img
                ref={this.bannerDefaultRef}
                src={defaultBanner}
                className={`img-fluid w-100  ${
                  this.state.isLoadingImage ? "" : "d-none"
                } `}
                alt={game.get("name")}
              />
              {game && game.get("jackpotBalance") && (
                <div className="jackpot-amount">
                  {this.getTotalPool(this.state.jackpotPool, game, false)}
                </div>
              )}
              {gameLimit && gameLimit.get("minBet") && (
                <div className="game-limits">
                  <span className="min-bet">
                    {currencyFormatter(gameLimit.get("minBet"), {
                      symbol: this.props.symbol,
                      currency: this.props.currency,
                      dropZeroDecimals: true,
                    })}
                  </span>
                </div>
              )}
              {!this.props.isOneClickPlayEnabled && (
                <div
                  className={`actions nopadding row w-100 ${
                    this.state.hovered ? "" : "d-none"
                  }`}
                >
                  <div className="col nopadding d-flex  justify-content-center align-items-center">
                    {this.props.linkReal && (
                      <div
                        className="play-button text-center"
                        onClick={(event) => {
                          if (this.props.onClick) {
                            this.props.onClick(this.props.linkReal.get("rel"));
                          }
                          event.stopPropagation();
                        }}
                      >
                        <PlayIcon />
                      </div>
                    )}
                    {this.props.linkDemo && (
                      <div className="demo-button">
                        <button
                          className="btn-secondary"
                          onClick={(event) => {
                            if (this.props.onClick) {
                              this.props.onClick(
                                this.props.linkDemo.get("rel"),
                              );
                            }
                            event.stopPropagation();
                          }}
                        >
                          {this.props.linkDemo.get("name")}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className={`labelRow ${searchArr ? "with-search" : ""}`}>
              <span className="label">
                <Fragment>
                  <div className="name">
                    {!searchArr
                      ? game.get("name")
                      : this.checkSentence(game.get("name"), searchArr)}
                  </div>
                  <div className="provider">
                    {!searchArr
                      ? game.get("provider")
                      : this.checkSentence(game.get("provider"), searchArr)}
                  </div>
                  <div className="game-type">
                    {!searchArr
                      ? game.get("gameType")
                      : this.checkSentence(game.get("gameType"), searchArr)}
                  </div>
                </Fragment>
              </span>
              {
                <div className="game-feature">
                  {game.get("hasFreeRounds") && (
                    <div className="game-feature-badge ribbonIcon">
                      <RibbonIcon
                        color="rgba(255, 204, 0, 1)"
                        selectedcolor=""
                      />
                    </div>
                  )}
                  {game.get("partOfOnGoingTournament") && (
                    <div className="game-feature-badge trophyIcon">
                      <TrophyIcon
                        color="rgba(255, 204, 0, 1)"
                        selectedcolor=""
                      />
                    </div>
                  )}
                  {game.get("isJackpot") && (
                    <div className="game-feature-badge jackpotIcon">
                      <CrownIcon color="rgba(255, 204, 0, 1)" />
                    </div>
                  )}
                  {game.get("isFeatured") && (
                    <div className="game-feature-badge editorsChoiceIcon">
                      <EditorsChoiceIcon color="rgba(255, 204, 0, 1)" />
                    </div>
                  )}
                </div>
              }
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Category;
